module.exports = __webpack_public_path__ + "static/media/CDR.4e0f397f.svg";